<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">


      <b-row class=" mt-10 ml-5 mr-5">
        <b-col sm="12">
          <b-button v-b-modal.modalPopover variant="primary" class="float-right"
            style="padding-top: 6px; padding-bottom: 6px">
            {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
          </b-button>
          <b-modal id="modalPopover" size="xl" :hide-header="true" :hide-footer="true" :centered="true" @show="onShow()"
            @hide="onHide()">
            <div class="row mt-5">
              <div class="col-lg-12">
                <b-form @submit.stop.prevent="onSubmit">
                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h3>{{ $t("PAGE.MANGROVE.FORM.FIELDS.DATA") }} </h3>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">

                    <b-col sm="2">
                      <label>
                        <h5>{{ $t("PAGE.MANGROVE.FORM.FIELDS.NAME") }} : </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="name-input" name="name-input" type="text" v-model="$v.form.name.$model"
                        :state="validateState('name')" aria-describedby="name-live-feedback"></b-form-input>

                      <b-form-invalid-feedback id="name-live-feedback">
                        <span v-if="!$v.form.name.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>

                    </b-col>
                  </b-row>
                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h5>
                          {{ $t("PAGE.USER.FORM.FIELDS.VIDEOURL") }}
                        </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="email-input" name="email-input" type="text"
                      v-model="$v.form.video_url.$model" :state="validateState('video_url')" aria-describedby="name-live-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="name-live-feedback">
                        <span v-if="!$v.form.video_url.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h5>
                          SnapShot
                        </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="email-input" name="email-input" type="text"
                      v-model="$v.form.snapshot.$model" :state="validateState('snapshot')" aria-describedby="name-live-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="name-live-feedback">
                        <span v-if="!$v.form.snapshot.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">
                    <b-col sm="12">
                      <b-button @click="open_stream = !open_stream" variant="primary" class="btn-stream">{{
                      $t("PAGE.DEFAULT.FORM.TESTVIDEO")
                      }}</b-button>
                    </b-col>
                  </b-row>

                  <b-row v-if="open_stream" class="mb-5">
                    <b-col sm="2">
                    </b-col>
                    <b-col sm="10">
<!--                       <video id="player_html5_api" class="vjs-tech" playsinline="playsinline" tabindex="-1" role="application" muted="muted" src="blob:https://caoss.ardangar.com/1fd8ad30-e498-407a-999a-c4f0ffee4048"></video>
 -->                <b-embed type="iframe" aspect="16by9" :src=$v.form.video_url.$model allowfullscreen></b-embed>
                    </b-col>
                  </b-row>
                  <b-col sm="12">
                    <b-button class="float-right" @click.prevent="cancel()">{{
                    $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                    }}</b-button>
                    <b-button type="submit" variant="primary" class="float-right mr-3">{{
                    $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                    }}</b-button>
                  </b-col>

                </b-form>
              </div>
            </div>
          </b-modal>
        </b-col>
      </b-row>
      <div class="card-body pt-0 pb-3 mt-4">
        <div class="tab-content">
          <div class="table-responsive">
            <b-table striped hover :items="items" :per-page="perPage" :current-page="currentPage" :fields="fields">
              <template #cell(action)="data">
                <a href="javascript:" @click="openSetUpdate(data.item.id)" class="btn btn-icon btn-light btn-sm"
                  v-b-tooltip.hover :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')">
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <inline-svg src="media/svg/icons/General/Edit.svg"></inline-svg>
                  </span> </a>&nbsp;&nbsp;&nbsp;
                <a href="javascript:" @click.prevent="removeData(data.item.id)" class="btn btn-icon btn-light btn-sm"
                  v-b-tooltip.hover :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')">
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                  </span>
                </a>
              </template>
            </b-table>

          </div>
          <div class="row justify-content-between">
            <div div class="col-lg-2">
              <b-form-group id="name-input-group" :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')" label-for="name-input"
                label-cols="7" label-align-sm="left" label-size="lg">
                <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="paginationOptions">
                </b-form-select>
              </b-form-group>
            </div>
            <div div class="col-lg-2">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.btn-stream {
  margin-left: 15rem;
}

.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>
import { VIDEO_CREATE_DATA, DELETE_VIDEO_DATA, PAGINATION_VIDEO_URL_DATA, CLEAR_PAGINATION, PUT_VIDEO_DATA, GET_VIDEO_DATA } from "@/core/services/store/videoStream.module";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
export default {
  components: {

  },

  data() {
    return {
      mangrove_location_id: 0,
      id: 0,
      modalShow: false,
      open_stream: false,
      perPage: 25,
      currentPage: 1,
      paginationOptions: [25, 50, 100, 200],
      items: [
      ],
      fields: [
      {
          key: "name",
          label: "ชื่อ",
          key_table: "name",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },
        {
          key: "video_url",
          label: "video_url",
          key_table: "name",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },
        {
          key: "snapshot",
          label: "snapshot_url",
          key_table: "name",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },
        {
          key: "action",
          label: `${this.$t("PAGE.POINTS_COULD.FORM.FIELDS.ACTION")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],

      form: {
        video_url: "",
        snapshot:'',
        name:""
      },
    };
  },
  validations: {
    form: {
      snapshot: {required},
      video_url: {required},
      name:{required}


    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  mounted() {
    this.fetchData()
    this.mangrove_location_id = this.$route.params.id
  },
  methods: {
    openSetUpdate(id) {
      this.$bvModal.show("modalPopover");
      this.get(id)
    },
    cancel() {
      this.form.video_url = ''
      this.$bvModal.hide("modalPopover")
      this.onHide();
    },
    getParams() {
      if (this.mangrove_location_id == undefined) {
        this.mangrove_location_id = this.$store.state.mangrove_location.data_pram.mangrove_location_id
      }
      return {
        mangrove_location_id: this.$store.state.mangrove_location.data_pram.mangrove_location_id
      }
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_VIDEO_URL_DATA, { params: this.getParams() })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            confirmButtonColor: '#840000'
          });
          this.isBusy = false;
        });
    },
    removeData(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`,
        confirmButtonColor: '#840000'
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_VIDEO_DATA, { id })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.fetchData();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
              this.isBusy = false;
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
              this.isBusy = false;
            });
        }
      });
    },

    get(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_VIDEO_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.id = data.data.id
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    onSubmit() {

      let formData = new FormData();
      let id = this.id
      formData.append("mangrove_location_id", this.$store.state.mangrove_location.data_pram.mangrove_location_id);
      formData.append("video_url", this.form.video_url);
      formData.append("snapshot", this.form.snapshot);
      formData.append("name", this.form.name);

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if (this.id > 0) {
        this.update(id, formData)
      } else {
        this.create(formData);
      }
    }
    ,
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_VIDEO_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.id = 0
                this.form.video_url = ''
                this.fetchData()
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("modalPopover")
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(VIDEO_CREATE_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success") {
                this.form.video_url = ''
                this.fetchData();
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("modalPopover")
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  }
};
</script>
